import React, { useEffect, useState } from 'react'
import { Box, Stack, Table, TableHead, TableContainer, Skeleton, TableBody, TableCell, TableRow, PaginationItem, Pagination,Divider } from "@mui/material";
import { StyledTableRow, StyledTableCell } from "../../Theme"
// import { colors } from '../../Theme/tokens';
import { useColors } from '../../Theme/ColorModeContext';
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import { FaMinus } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { ReactComponent as PlusIcon } from '../../img/transactions/despositIcon.svg';
import { ReactComponent as MinusIcon } from '../../img/transactions/withdrawIcon.svg';
import { ReactComponent as PaginationForwardIcon } from '../../img/PaginationForwardIcon.svg';
import { ReactComponent as PaginationBackArrowIcon } from '../../img/PaginationBackArrow.svg';
import ChooseYourMethod from './ChooseYourMethod';
import { ApiService } from '../../API/AxiosInstance';
import { getTransactionColor } from '../Overview';
import moment from 'moment';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import FeatureSoon from '../../components/FeatureSoon';
import BankDetailsModal from './BankDetailsModal';
import { captureException } from '@sentry/react';
import MainLayout from '../../components/MainLayout';
// import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { ReactComponent as PauseCircleIcon } from '../../img/transactions/holdIcon.svg';

export default function Transactions() {
    const [transactions, setTransactions] = useState([])
    const [pagination, setPagination] = useState({ currentPage: 0, currentSize: 1, hasMore: false });
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ""
    const [loading, setLoading] = useState(false)
    const [contactModal, setContactModal] = useState(false)
    const [transactionType, setTransactionType] = useState('')
    const [bankDetailModal, setBankDetailModal] = useState(false)
    const colors = useColors()

    const showBankDetails = () => {
      setBankDetailModal(true)
    }

    const handleContactUs = (type) => {
      setContactModal(true)
      setTransactionType(type)
    }
    
    const handleContactUsClose = () => {
      setContactModal(false)
    }

    const handlePaginationChange = (event, page) => {
        setPagination(prev=>({...prev, currentPage: page - 1}))
        getRecentTransactions(page - 1)
    }

    const getRecentTransactions = async(currentPage) => {
        setLoading(true)
        try {
          const response =  await ApiService().get(`portfolios/transactions?userId=${userId.sub_id}&limit=10&page=${currentPage}`)
         if(response?.data?.portfolioTransactions?.length > 0) {
            setTransactions(response?.data?.portfolioTransactions?.filter(item => !item.isArchived ))
            setPagination({
                currentPage: response.data.pagination.currentPage,
                currentSize: response.data.pagination.currentSize,
                hasMore: response.data.pagination.hasMore
            });
          
         }
         setLoading(false)
    
       } catch(error) {
        setLoading(false)
        captureException(error)
       }
      }

      useEffect(() => {
        if(userId) getRecentTransactions(pagination.currentPage);
    }, []);

    return (
        <>
            <FeatureSoon open={contactModal} transactionType={transactionType} handleContactUsClose={handleContactUsClose} />
            <MainLayout>
              <Box sx={{
                    borderTopLeftRadius: "18px",
                    borderTopRightRadius: '18px',
                    backgroundColor: 'white',
                    boxShadow:`0px 1px 5px 0px ${colors.border.card}`
              }}>
                  <Box columnGap={4} rowGap={3} sx={{
                    padding: {
                        sm: '20px 30px 35px 30px',
                        xs: '20px 15px 35px 15px'
                    },
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: { xs: 'column', md: 'row' }
                }}>
                    <Box rowGap={2} sx={{ display: 'flex', flexDirection: 'column', }}>
                        <Typography variant='h2' sx={{color:colors.text.primary, fontWeight:"600"}}>Transactions</Typography>
                        <Typography variant='h6' sx={{color:colors.text.gray}}>Your transaction since inception</Typography>
                    </Box>

                    <Box columnGap={2} rowGap={2} sx={{ display: 'flex', flexDirection: { md: 'column', lg: 'row' } }}>
                        {/* <ChooseYourMethod /> */}
                        <BankDetailsModal bankDetailModal={bankDetailModal} setBankDetailModal={setBankDetailModal} />
                        <Button onClick={showBankDetails} endIcon={<MdAdd />} sx={{ width: '140px' }} variant='contained' >Add Deposit</Button>
                        {/* <Button endIcon={<FaMinus />} sx={{ width: '140px' }} variant='outlined' >Withdraw</Button> */}
                        <Button onClick={()=> handleContactUs('withdrawal')} endIcon={<FaMinus />} sx={{ width: '140px' }} variant='contained' >Withdraw</Button>
                    </Box>
                </Box>
                <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
                    <Divider sx={{border: 0, borderBottom: `1px solid ${colors.border.cardDiv}`,opacity: 1,mt: 1,height:"0px",backgroundColor: colors.border.cardDiv, width:"95%"}} />
                </Box>
                <Box component='div' mt={.5} >
                    <TableContainer sx={{ backgroundColor: 'White_color', borderRadius: '0 0 10px 10px', padding:"0 20px 0 0" }}>
                       {!loading ? (
                       transactions?.length > 0 ? ( <Table aria-label="simple table">
                            <TableHead >
                                <StyledTableRow sx={{ '.MuiTableCell-root': { color: colors.text.header, textAlign: 'center',fontSize:"18px" } }}>
                                    <StyledTableCell sx={{width:"200px !important"}}>Date</StyledTableCell>
                                    <StyledTableCell>Amount</StyledTableCell>
                                    
                                    {/* <StyledTableCell sx={{textAlign:"left !important",width:"200px !important", paddingLeft:"64px !important"}}>Type</StyledTableCell> */}
                                    <StyledTableCell sx={{textAlign:"left !important",width:"200px !important"}}>Type</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                              {transactions?.map((item, index) => (
                                <StyledTableRow key={index} sx={{ '.MuiTableCell-root': { textAlign: 'center' } }}>
                                  <StyledTableCell sx={{fontWeight: "500 !important",}}>
                                    <Box columnGap={{ xs: 1, sm: 3 }}
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                      }}
                                    >
                                      {getTransactionColor(item.type,colors) === colors.secondary.main ? (
                                        <PlusIcon />
                                      ) : getTransactionColor(item.type,colors) === 'yellow' ? (
                                        <PauseCircleIcon sx={{ color: '#FFC107' }} />
                                      ) : (
                                        <MinusIcon />
                                      )}
                                      <Box>
                                        <Typography variant='h5_1' >{moment.utc(item.transferDate).local().format('DD MMM YYYY')} </Typography>
                                      </Box>
                                    </Box>
                                  </StyledTableCell>
                                  <StyledTableCell  sx={{
                                color: getTransactionColor(item.type,colors) === colors.secondary.main
                                  ? colors.secondary.main
                                  : getTransactionColor(item.type,colors) === 'yellow'
                                    ? "#FFC107"
                                    : colors.error.main
                              }}>
                                    {getTransactionColor(item.type,colors) === colors.secondary.main ? '+' : getTransactionColor(item.type,colors) === 'yellow' ? '' : '-'} $ {parseFloat(item?.amount)?.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{fontWeight: "500 !important", fontSize: "17px", textAlign: "left !important" }}>
                                    {item.type}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                        </Table>) : ( <Box 
                        sx={{ 
                          display: "flex", 
                          justifyContent: "center", 
                          alignItems: "center", 
                          height: "100%" ,
                          minHeight:"400px"
                        }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            mb: { xs: 2, lg: 0 },
                            color: colors.text.tertiary,
                            fontWeight: "500",
                            fontSize: { xs: "18px", lg: "18px" }
                          }}
                        >
                          No Transactions
                        </Typography>
                      </Box>)
                        ) : (
                            <Table>
                            <TableBody>
                              {Array.from(new Array(5)).map((_, rowIndex) => (
                                <TableRow key={rowIndex}>
                                  {Array.from(new Array(3)).map((_, colIndex) => (
                                    <TableCell key={colIndex}>
                                       <ShimmerSkeleton variant="rectangular" width="100%" height={40} />
                                    </TableCell>
                                  ))}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        )}
                    </TableContainer>
                </Box>
              </Box>

           {transactions?.length > 0 && pagination?.hasMore && 
            // <Stack mt={4} direction='row' justifyContent='center' spacing={2}>
            //     <Pagination
            //         count={pagination.hasMore ? pagination.currentPage + 2 : pagination.currentPage + 1}
            //         sx={{
            //             '.MuiPaginationItem-circular': { backgroundColor: 'white' },
            //             '.Mui-selected': { backgroundColor: '#3F7DBC !important', color: 'white' },
            //             '.Mui-selected:hover': { backgroundColor: '#3F7DBC', color: 'white' }
            //         }}
            //         onChange={handlePaginationChange }
            //         page={pagination.currentPage + 1}
            //         renderItem={(item) => (
            //             <PaginationItem slots={{ previous: PaginationBackArrowIcon, next: PaginationForwardIcon }} {...item} />
            //         )}
            //     />
            // </Stack>
            <Stack mt={4} direction='row' justifyContent='center' spacing={2}>
            <Pagination
              count={pagination.hasMore ? pagination.currentPage + 2 : pagination.currentPage + 1}
              sx={{
                '.MuiPaginationItem-circular': { backgroundColor: 'white' },
                '.Mui-selected': { backgroundColor: `${colors.primary.main} !important`, color: 'white' },
                '.Mui-selected:hover': { backgroundColor: colors.primary.main, color: 'white' }
              }}
              onChange={handlePaginationChange}
              page={pagination.currentPage + 1}
              renderItem={(item) => (
                item.type === 'previous' || item.type === 'next' ? (
                  <PaginationItem 
                    slots={{ previous: PaginationBackArrowIcon, next: PaginationForwardIcon }} 
                    {...item} 
                  />
                ) : null
              )}
            />
          </Stack>
            }
            </MainLayout>
        </>
    )
}
